import React, { useState } from "react";
import "./ProductCard.css";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";

const ProductCard = ({
  item,
  handleCalculate,
  setIsOpenAddProduct,
  setEditDetails,
  handleDelete,
}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <div class="product-card">
        <div class="card-header">
          <h3 class="product-title">{item?.productId ?? ""}</h3>

          <div className="header-left" style={{ marginLeft: "2rem" }}>
            <div class="product-desc">{item?.productDesc ?? ""}</div>
            <button
              className="edit-btn"
              style={{
                marginLeft: "2rem",
                marginRight: "1rem",
                padding: "8px 12px",
                borderRadius: "8px",
              }}
              onClick={() => {
                setIsOpenAddProduct(true);
                setEditDetails(item);
              }}
            >
              <BorderColorIcon
                style={{
                  fontSize: "20px",
                  color: "#fff",
                  marginLeft: "4px",
                }}
              />
            </button>
            <button
              className="delete-btn-header"
              onClick={() =>
                handleDelete && handleDelete(item?.productId ?? "")
              }
              style={{
                background: "linear-gradient(145deg, #dc3545, #c82333)",
                border: "none",
                borderRadius: "50%",
                width: "38px",
                height: "38px",
                color: "#ffffff",
                fontSize: "12px",
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                marginLeft: "10px",
              }}
            >
              <DeleteIcon
                style={{
                  fontSize: "18px",
                  color: "#fff",
                }}
              />
            </button>
          </div>
        </div>

        <div className={`details-container ${showMore ? "show-more" : "show-less"}`}>
          <div class="details-grid">
          <div class="detail-item">
            <div class="detail-label">Processing Fee</div>
            <div class="detail-value">
              {(item?.processingFee ?? "").toString()}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Interest Rate</div>
            <div class="detail-value">
              {(item?.interestRate ?? "").toString()}
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Number of EMIs</div>
            <div class="detail-value">{(item?.noOfEmi ?? "").toString()}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Deployment Ratio</div>
            <div class="detail-value">
              {(item?.deploymentRatio ?? "0").toString()}%
            </div>
          </div>

          <div class="detail-item">
            <div class="detail-label">Deployment Number</div>
            <div class="detail-value">
              {(item?.deploymentNum ?? "").toString()}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Product Weightage</div>
            <div class="detail-value">
              {(item?.productWeightage ?? "").toString()}%
            </div>
          </div>

          {/* Hidden attributes that show on "See More" - kept in DOM with transition classes */}
          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">APR</div>
            <div class="detail-value">{(item?.apr ?? "").toString()}%</div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Risk Factor</div>
            <div class="detail-value">
              {(item?.riskFactor ?? "").toString()}%
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Average Ticket Size</div>
            <div class="detail-value currency">
              {(item?.averageTicketSize ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Conversion Ratio</div>
            <div class="detail-value">
              {(item?.conversionRatio ?? "").toString()}%
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Penalty Charge</div>
            <div class="detail-value">
              {(item?.penaltyCharge ?? "").toString()}%
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Product Name</div>
            <div class="detail-value">
              {(item?.productName ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Ticket Size</div>
            <div class="detail-value currency">
              {(item?.ticketSize ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Cibil Score</div>
            <div class="detail-value">
              {(item?.cibilScore ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Employment Type</div>
            <div class="detail-value">
              {(item?.employmentType ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Salary Bracket</div>
            <div class="detail-value currency">
              {(item?.salaryBracket ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Tenure</div>
            <div class="detail-value">
              {(item?.tenure ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Age</div>
            <div class="detail-value">{(item?.age ?? "").toString()}</div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">DBR</div>
            <div class="detail-value">{(item?.dbr ?? "").toString()}%</div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Delinquency</div>
            <div class="detail-value">
              {(item?.delinquency ?? "").toString()}
            </div>
          </div>

          <div class={`detail-item extra-item ${showMore ? 'visible' : ''}`}>
            <div class="detail-label">Gaming Activity</div>
            <div class="detail-value">
              {(item?.gamingActivity ?? "").toString()}
            </div>
          </div>
        </div>
      </div>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <button
            className="see-more-btn"
            onClick={(event) => {
              setShowMore(!showMore);
              // Add smooth transition effect
              const button = event.currentTarget;
              
              // Remove any existing transitions first
              button.style.transition = 'none';
              
              // Apply scale down animation
              requestAnimationFrame(() => {
                button.style.transform = 'scale(0.95)';
                button.style.transition = 'transform 0.1s cubic-bezier(0.4, 0, 0.2, 1)';
              });
              
              // Scale back up after delay
              setTimeout(() => {
                requestAnimationFrame(() => {
                  button.style.transform = 'scale(1)';
                  button.style.transition = 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
                });
              }, 100);
            }}
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "20px",
              color: "#ffffff",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              padding: "8px 16px",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
              minWidth: "80px",
              minHeight: "32px",
            }}
            onMouseOver={(event) => {
              event.target.style.background = "rgba(255, 255, 255, 0.2)";
              event.target.style.transform = "translateY(-2px) scale(1.02)";
            }}
            onMouseOut={(event) => {
              event.target.style.background = "rgba(255, 255, 255, 0.1)";
              event.target.style.transform = "translateY(0) scale(1)";
            }}
          >
            {showMore ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#005b56" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-arrow-up-icon lucide-circle-arrow-up">
                <circle cx="12" cy="12" r="10"/>
                <path d="m16 12-4-4-4 4"/>
                <path d="M12 16V8"/>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#005b56" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-chevron-down-icon lucide-circle-chevron-down">
                <circle cx="12" cy="12" r="10"/>
                <path d="m16 10-4 4-4-4"/>
              </svg>
            )}
          </button>
        </div>

        <button
          class="calculate-btn"
          onClick={() => handleCalculate(item?.productId ?? "")}
        >
          Calculate
        </button>
      </div>
    </>
  );
};

export default ProductCard;
